const ViewError = () => (
  <div className="viewer-screen">
    <div className="title-container">
      <p className="title-fullscreen">Obrazovka nenalezena</p>
    </div>
  </div>
);

export default ViewError;
